module.exports = __webpack_public_path__ + "static/media/tour-info.292621d0.png";